import * as firebase from "firebase/app";
import "firebase/firestore";
import * as types from "../types";


// This React App can use Firebase and is deployed to Firebase Hositng for testing
// Initialize Firebase
var config = {
  apiKey: "AIzaSyD63oyKklok4XPbCJxEmLCL2oz0qFG97Y0",
  authDomain: "data-collection-73a5c.firebaseapp.com",
  databaseURL: "https://data-collection-73a5c.firebaseio.com",
  projectId: "data-collection-73a5c",
  storageBucket: "data-collection-73a5c.appspot.com",
  messagingSenderId: "59115248028"
};
firebase.initializeApp(config);
const db = firebase.firestore();
const settings = { /* your settings... */ timestampsInSnapshots: true };
db.settings(settings);

db.enablePersistence({ experimentalTabSynchronization: true })
  .then(() => {
    console.log("Woohoo! CWD Multi-Tab Persistence!");
  })
  .catch(function(err) {
    if (err.code === "failed-precondition") {
      // Multiple tabs open, persistence can only be enabled
      // in one tab at a a time.
      // ...
    } else if (err.code === "unimplemented") {
      // The current browser does not support all of the
      // features required to enable persistence
      // ...
    }
  });

export function submitForm(data, callback) {
  const dt = new Date();
  const time = dt.toLocaleTimeString();
  const date = dt.toLocaleDateString();

  const SUCCESS = "SUCCESS";
  const FAILED = "FAILED";

  db.collection("Samples")
    .add({
      "Time Stamp": `${date}:${time}`,
      ...data
    })
    .then(function(docRef) {
      callback(SUCCESS);
    })
    .catch(function(error) {
      callback(FAILED);
    });

  db.collection("Samples")
    .where("Time Stamp", "==", `${date}:${time}`)
    .onSnapshot({ includeMetadataChanges: true }, function(snapshot) {
      snapshot.docChanges().forEach(function(change) {
        if (change.type === "added") {
          callback(SUCCESS);
        }
      });
    });

  return {
    type: types.SUBMIT_FORM
  };
}



// WEBPACK FOOTER //
// ./src/actions/Firebase/firebaseActions.js